export const activity = {
  activityWebEmptyStateTitle: 'Sin actividad todavía',
  activityWebEmptyStateText: 'Aquí estará tu feed de notificaciones',
  activitySeeAll: 'Ver todo',
  in: 'en'
}
